// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const FileArchiveIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="file-archive" fill="none" fillRule="nonzero" stroke="none" strokeWidth={1}><path id="Rectangle" fill="#FFF" d="M5 3h9l5 5v13H5z" /><path id="Shape" fill="currentColor" d="M6 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.825.588-1.413A1.93 1.93 0 0 1 6 2h8l6 6v4h-2V9h-5V4H6v16h9v2zm13 0 4-4-1.4-1.4-1.6 1.6V14h-2v4.2l-1.6-1.6L15 18zM6 20V4z" /></g></svg>
))
